import React from 'react';
import { connectStats } from 'react-instantsearch-dom';

const Stats = ({ nbHits }: any) => {
    return (
        <>
            {nbHits.toLocaleString()} result{nbHits !== 1 ? 's' : ''}
        </>
    );
};

const CustomStats = connectStats(Stats);

export default CustomStats;
